const DEFAULT_MAX_LENGTH_QUANTITY = 1414;

Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.SMS = {
  template: () => ({
    tag: 'div',
    items: [
      {
        items: [
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.phone',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'smsToCurrentCustomer',
                },
              },
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'radio',
                          id: 'smsToCurrentCustomer',
                          name: 'radio_sms',
                          checked: 'checked',
                          class: 'modelAttribute',
                        },
                      },
                    ],
                  },
                ],
                attributes: {
                  class: 'control-label radioSms',
                },
              },
            ],
            attributes: {
              class: 'control-radio',
            },
          },
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.managers',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'smsToManagers',
                },
              },
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'radio',
                          id: 'smsToManagers',
                          name: 'radio_sms',
                          class: 'modelAttribute',
                        },
                      },
                    ],
                  },
                ],
                attributes: {
                  class: 'control-label radioSms',
                },
              },
            ],
            attributes: {
              class: 'control-radio',
            },
          },
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.customer',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'smsToAllCustomers',
                },
              },
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'radio',
                          id: 'smsToAllCustomers',
                          name: 'radio_sms',
                          class: 'modelAttribute',
                        },
                      },
                    ],
                  },
                ],
                attributes: {
                  class: 'control-label radioSms',
                },
              },
            ],
            attributes: {
              class: 'control-radio',
            },
          },
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.eventLocation',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'smsToEventLocation',
                },
              },
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'radio',
                          id: 'smsToEventLocation',
                          name: 'radio_sms',
                          class: 'modelAttribute',
                        },
                      },
                    ],
                  },
                ],
                attributes: {
                  class: 'control-label radioSms',
                },
              },
            ],
            attributes: {
              class: 'control-radio',
            },
          },
          {
            items: [
              {
                tag: 'label',
                items: [
                  {
                    tag: 'span',
                    html: 'event.sms.drivers',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  class: 'control-label',
                  for: 'smsToDrivers',
                },
              },
              {
                items: [
                  {
                    tag: 'label',
                    items: [
                      {
                        tag: 'input',
                        attributes: {
                          type: 'radio',
                          id: 'smsToDrivers',
                          name: 'radio_sms',
                          class: 'modelAttribute',
                        },
                      },
                    ],
                  },
                ],
                attributes: {
                  class: 'control-label radioSms',
                },
              },
            ],
            attributes: {
              class: 'control-radio',
            },
          }
        ],
        attributes: {
          class: 'group-radio',
        },
      },
      {
        items: [
          {
            tag: 'label',
            items: [
              {
                tag: 'span',
                html: 'event.sms.to',
                attributes: {
                  class: 'i18nResource',
                },
              },
            ],
            attributes: {
              class: 'control-label',
              for: 'action_sms_to',
            },
          },
          {
            items: [
              {
                tag: 'input',
                attributes: {
                  type: 'text',
                  maxlength: '80',
                  name: 'action_sms_to',
                  id: 'action_sms_to',
                  class: 'modelAttribute textField mandatory',
                  autocomplete: 'off',
                },
              },
            ],
            attributes: {
              class: 'controls sms',
            },
          },
        ],
        attributes: {
          class: 'hideShowActionSmsTo',
        },
      },
      {
        tag: 'div',
        items: [
          {
            tag: 'label',
            items: [
              {
                tag: 'span',
                html: 'event.sms.text',
                attributes: {
                  class: 'i18nResource',
                },
              },
            ],
            attributes: {
              class: 'control-label',
              for: 'action_sms_text',
            },
          },
          {
            items: [
              {
                tag: 'textarea',
                attributes: {
                  cols: '110',
                  rows: '4',
                  name: 'action_sms_text',
                  id: 'action_sms_text',
                  maxlength: DEFAULT_MAX_LENGTH_QUANTITY,
                  class: 'modelAttribute textAreaField mandatory',
                },
              },
              {
                tag: 'div',
                attributes: {
                  class: 'charactersLeft',
                },
                items: [
                  {
                    tag: 'label',
                    html: Monet.I18n.getResourcesByKey(
                      'event.textarea.charactersLeft', 
                      DEFAULT_MAX_LENGTH_QUANTITY
                    ),
                    attributes: {
                      class: 'i18nResource text',
                    },
                  }
                ]
              }
            ],
            attributes: {
              class: 'controls',
            },
          },
        ],
        attributes: {
          class: 'sms-text-container control-group'
        }
      },
    ],
  }),
  addListener: () => {
    const receivedSms = document.getElementsByName('radio_sms');
    const divInputTo = document.querySelector('.hideShowActionSmsTo');
    const inputTo = document.querySelector('#action_sms_to');
    const smsTextArea = document.getElementById("action_sms_text");

    for (let i = 0; i < receivedSms.length; i++) {
      receivedSms[i].addEventListener('click', (e) => {
        switch (e.target.id) {
          case 'smsToCurrentCustomer':
            divInputTo.classList.remove('hideField');
            inputTo.className = 'modelAttribute textField mandatory';
            break;
          case 'smsToEventLocation':
          case 'smsToAllCustomers':
          case 'smsToManagers':
          case 'smsToDrivers':
            inputTo.value = '';
            divInputTo.classList.add('hideField');
            inputTo.className = 'modelAttribute textField';
            break;
          default:
            return false;
        }
      });
    }
    
    Greenmile.Event.EventActionUtil.addListenerToCountSizeInElement(
      smsTextArea, 
      ".sms-text-container .charactersLeft .text", 
      "event.textarea.charactersLeft", 
      "SMS", 
      DEFAULT_MAX_LENGTH_QUANTITY
    );
  },
  prepareBodyComponent: () => {
    const CONTAINER_SELECTOR = '.sms-text-container';
    const container = document.querySelector(CONTAINER_SELECTOR);
    const selectFieldList = new Greenmile.Event.SelectFieldList(CONTAINER_SELECTOR);
    const smsTextArea = document.getElementById("action_sms_text");
    selectFieldList.setAvailableTags(Greenmile.Event.AutoComplete.loadSmsAvailableTags());

    selectFieldList.addClickEventListener((field) => {
      const fieldValue = field.value;
      const smsTextAreaValue = smsTextArea.value;
      const textAreaLengthWithFieldLength = smsTextAreaValue.length + fieldValue.length;

      if (textAreaLengthWithFieldLength > DEFAULT_MAX_LENGTH_QUANTITY) {
        return;
      }

      if (field && (!smsTextAreaValue.includes(fieldValue))) {
        smsTextArea.value += fieldValue;

        var event = document.createEvent('Event');
        event.initEvent('input');
        smsTextArea.dispatchEvent(event);
      }
    });
    selectFieldList.render();

    container.appendChild(selectFieldList.elFieldList);
  },
  assignParameter: (jsonParam) => {
    let divInputTo = null;
    let inputTo = null;
    let inputSmsText = null;
    const data = (jsonParam) ? JSON.parse(jsonParam) : {};

    if (data.toSupervisors) {
      document.querySelector('input[name="radio_sms"]#smsToManagers').checked = true;
    }

    if (data.toCurrentCustomer) {
      document.querySelector('input[name="radio_sms"]#smsToCurrentCustomer').checked = true;
    }

    if (data.toAllCustomers) {
      document.querySelector('input[name="radio_sms"]#smsToAllCustomers').checked = true;
    }

    if (data.smsToEventLocation) {
      document.querySelector('input[name="radio_sms"]#smsToEventLocation').checked = true;
    }

    if (data.toDrivers) {
      document.querySelector('input[name="radio_sms"]#smsToDrivers').checked = true;
    }

    if (typeof data.toCurrentCustomer !== 'undefined' && !data.toCurrentCustomer) {
      divInputTo = document.querySelector('.hideShowActionSmsTo');
      divInputTo.classList.add('hideField');
      divInputTo.children[1].children[0].className = 'modelAttribute textField';
    }

    if (typeof data.to !== 'undefined' && data.to.indexOf(',') !== -1) {
      inputTo = document.querySelector('#action_sms_to');
      inputTo.value = data.to.join();
    } else {
      inputTo = document.querySelector('#action_sms_to');
      inputTo.value = data.to;
    }

    inputSmsText = document.querySelector('#action_sms_text');
    inputSmsText.value = data.text;

    const params = {
      element: inputSmsText,
      label: '.sms-text-container .charactersLeft .text',
      resourceKey: 'event.textarea.charactersLeft',
      availableTags: 'SMS',
      maxlength: DEFAULT_MAX_LENGTH_QUANTITY,
      value: data.text
    };

    Greenmile.Event.EventActionUtil.updateMaxLengthWithAttributes(params);
  },

  retrieveParameter: () => {
    let smsTo = $('#action_sms_to');
    if (smsTo) {
      smsTo = smsTo.val().split(',');
    } else {
      smsTo = null;
    }

    return JSON.stringify({
      toAllCustomers: document.querySelector('input[name="radio_sms"]#smsToAllCustomers').checked,
      toCurrentCustomer: document.querySelector('input[name="radio_sms"]#smsToCurrentCustomer').checked,
      toSupervisors: document.querySelector('input[name="radio_sms"]#smsToManagers').checked,
      smsToEventLocation: document.querySelector('input[name="radio_sms"]#smsToEventLocation').checked,
      toDrivers: document.querySelector('input[name="radio_sms"]#smsToDrivers').checked,
      to: smsTo,
      text: $('#action_sms_text').val()
    });
  }
};
